import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/test',
  component: LAYOUT,
  name: 'Test',
  redirect: '/test/index',
  meta: {
    title: '话题详情',
  },
  children: [
    {
      path: 'index',
      name: 'TestIndex',
      meta: {
        title: '话题详情',
      },
      component: () => import('@/views/test/index'),
    },
  ],
};
